import { PileType } from 'src/games/phasersolitaire/logic/logic-types';
import { PileViewModel } from './pile-view-model';
import { GameServices } from '../../game-services';
import { Subject } from 'rxjs';

export class DeckPileViewModel extends PileViewModel {
  public get onShakeTrigger() {
    return this.onShake.asObservable();
  }

  private readonly onShake: Subject<void>;

  constructor(gameServices: GameServices) {
    super(gameServices, PileType.Deck);

    this.onShake = new Subject<void>();
  }

  public onPointerDown() {
    this.gameServices.gameRunnerService.drawNextCard();
  }

  public shakePile() {
    this.onShake.next();
  }
}
